import React, {Component} from "react";
import Header from "../../../Containers/Header/Header";
import Footer from "../../../Containers/Footer/index";
import PageTopMenu from "../../../Containers/PageTopMenu";
import CategoryIn from "../../../Buttons/CategoryIn/index";
import * as HomeworkService from "../../../../services/Student/HomeworkService";
import * as Utils from "../../../Utils";
import Loading from "../../../Containers/Loading";

class Vocab extends Component {
    state = {
        vocab: "Hello", // 향후 서버 데이터로 교체,
        title: "-",
        section: "-",

        // loading
        isLoadingHide: false
    }

    componentDidMount = () => {
        this._isMounted = true;
        if (Utils.isConnectedLocalServer()) {
            this.setState({
                title: "sample",
                section: "Life"
            });
        } else {
            this.getVocabHomework(Utils.getDate());
        }
        this.state.isLoadingHide = true;
    }

    componentWillUnmount = () => {
        this._isMounted = false;
    }

    getVocabHomework = (date) => {
        const that = this;
        HomeworkService.getVocabHomework(date).then((response) => {
            if (response !== null && response.status === 200) {
                // console.log(response.data.data.vocabulary);
                if (response.data !== null && response.data.code === '0000') {
                    if (that._isMounted) {
                        that.setState({
                            title: response.data.data.vocabulary[0].title,
                            section: response.data.data.vocabulary[0].section
                        });
                    }
                } else {
                    window.location.href = '/app/homework';
                }
            } else {
                console.log(response);
                alert('LOGIN ERROR');
            }
        }).catch(response => {
            console.log(response);
            alert('SERVER ERROR');
        });
    }

    render() {
        if (!this.state.isLoadingHide) {
            return (<Loading/>);
        }

        const {title, section} = this.state;

        return (
            <div className="beaconWrapper">
                <Header />
                <div className="allconWrapper">
                    <div className="contentsWrapper">
                        <h2 className="screenOut">오늘의 Vocabulary 숙제</h2>
                        <PageTopMenu />
                        <div className="pageContents">
                            <CategoryIn categoryState="on" categoryName="vocabulary" color="yellow" btnName="START"
                                        link="/app/vocabhomework" title={title} section={section}/>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

export default Vocab;



// WEBPACK FOOTER //
// ./src/components/Pages/Student/Vocab/index.js